export default __webpack_public_path__ + "static/media/jamuna-3.0d8803a5.PNG";